<template lang="pug">
transition-slide-vertical
  .__panel(v-if="visible", :class="{ wide: wide }")
    button.close(@click.prevent="$emit('close', false)")
    .inner
      slot
</template>

<script>
import { TransitionSlideVertical } from 'elysium-common/components/transition';

export default {
  model: {
    prop: 'visible',
    event: 'close',
  },
  components: {
    TransitionSlideVertical,
  },
  props: {
    visible: Boolean,
    wide: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
@import '../../stylus/helpers/mediaqueriesStep'

.__panel
  +tablet()
    width 100%

  +desktop()
    width 840px
    position absolute
    padding 30px
    border 2px dashed #33c275
    background #eee
    z-index 1000
    transition all .5s cubic-bezier(.21, .415, .37, 1.22)

  &:after
    display block
    width 0
    height 0
    line-height 0
    content ' '
    clear both

  &.wide
    width 100%

  .close
    display block
    position absolute
    top 18px
    right 18px
    width 15px
    height 15px
    background-color transparent
    border-width 0
    cursor pointer
    z-index 99999

    +phone()
      top 0
      right 0

    &:before,
    &:after
      position absolute
      top 6px
      left -1px
      width 17px
      height 3px
      content ''
      background-color #6e6bce
      transition background-color .3s ease

    &:before
      transform rotate(45deg)

    &:after
      transform rotate(-45deg)

    &:active,
    &:focus,
    &:hover
      outline 0

    &:hover
      &:before,
      &:after
        background-color #e25a5a

    &:active,
    &:focus
      &:before,
      &:after
        background-color: rgba(0, 0, 0, 0.85)
</style>



// WEBPACK FOOTER //
// Popup.vue?8173fc50